import { render, staticRenderFns } from "./AdditionalHeaderInformation.vue?vue&type=template&id=71d48a36"
import script from "./AdditionalHeaderInformation.vue?vue&type=script&lang=js"
export * from "./AdditionalHeaderInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports